// import * as actionTypes from './constants';
// import { updateObject } from '../../shared/utility';

// const initialState = {
//     isInitiated: false,
//     isSuccess: false,
//     isFailed: false,
//     errorMessage: null
// }
// const signupInitiated = (state) => {
//     return updateObject(state, {
//         isInitiated: true,
//         isSuccess: false,
//         isFailed: false
//     });
// }
// const signupSuccess = (state) => {
//     return updateObject(state, {
//         isInitiated: true,
//         isSuccess: true,
//         isFailed: false
//     });
// }
// const signupFailed = (state) => {
//     return updateObject(state, {
//         isInitiated: true,
//         isSuccess: false,
//         isFailed: true,
//         errorMessage: 'E'
//     });
// }
// const reducer = (state = initialState, action) => {
//     switch (action.type) {
//         case actionTypes.SIGNUP_INITIATED: return signupInitiated(state, action);
//         case actionTypes.SIGNUP_SUCCESS: return signupSuccess(state, action)
//         case actionTypes.SIGNUP_FAILED: return signupFailed(state, action)
//         default:
//             return state;
//     }
// }

// export default reducer;

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isInitiated: false,
	isSuccess: false,
	isFailed: false,
	errorMessage: null,
};

const signupSlice = createSlice({
	name: 'signup',
	initialState,
	reducers: {
		signupInitiated: state => {
			state.isInitiated = true;
			state.isSuccess = false;
			state.isFailed = false;
		},
		signupSuccess: state => {
			state.isInitiated = true;
			state.isSuccess = true;
			state.isFailed = false;
		},
		signupFailed: state => {
			state.isInitiated = true;
			state.isSuccess = false;
			state.isFailed = true;
			state.errorMessage = 'E';
		},
	},
});

export const { signupInitiated, signupSuccess, signupFailed } =
	signupSlice.actions;
export default signupSlice.reducer;
